
import Dialog from '@/components/common/Dialog.vue'
import Button from '@/components/detail/Button.vue'
export default {
  components: { Dialog, Button },
  props: {
    ispre: {
      // 是否显示上一步
      type: Boolean,
      default: false
    },
    isnext: {
      // 是否显示下一步
      type: Boolean,
      default: true
    },
    title: {
      // 弹框标题
      type: String,
      default: ''
    },
    isskip: {
      // 是否显示快速跳过
      type: Boolean,
      default: false
    },
    isstep: {
      // 是否显示步骤
      type: Boolean,
      default: true
    },
    dis: {
      // 下一步是否可点击
      type: Boolean,
      default: false
    },
    nexttext: {
      // 下一步按钮文本显示
      type: String,
      default: '完成验证'
    },
    nextstyle: {
      // 快速跳过，以后再选样式
      type: String,
      default: ''
    },
    skiptext: {
      // 快速跳过，以后再选显示文本
      type: String,
      default: '快速跳过，以后再选'
    },
    closeshow: {
      type: Boolean,
      default: false
    },
    idx: {
      type: Number,
      default: 1
    },
    headershow: {
      // 默认头部是否显示
      type: Boolean,
      default: true
    },
    operation: {
      // 是否显示人工客服和完成验证
      type: Boolean,
      default: false
    },
    valishow: {
      // 完成验证按钮是否显示
      type: Boolean,
      default: true
    },
    rgkfshow: {
      // 人工客服是否显示
      type: Boolean,
      default: true
    },
    iscreateserve: {
      // 是否显示创建服务商
      type: Boolean,
      default: false
    },
    helpshow: {
      type: Boolean,
      default: true
    },
    rightshow: {
      type: Boolean,
      default: true
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      load: false
    }
  },
  methods: {
    open() {
      // 打开弹框
      if (this.$store.state.mobile) {
        this.$nextTick(() => {
          document.getElementsByTagName('html')[0].style.overflow = 'hidden'
        })
      }
      this.$refs.adddialog.open()
    },
    close() {
      // 关闭弹框
      this.$refs.adddialog.close()
    },
    next() {
      // 下一步
      this.$emit('next')
    },
    pre() {
      // 上一步
      this.$emit('pre')
    },
    skipFn() {
      // 快速跳过按钮
      this.$emit('skipFn')
    },
    loadfn() {
      // 加载效果
      this.load = !this.load
    },
    closedialog() {
      if (this.$store.state.mobile) {
        document.getElementsByTagName('html')[0].style.overflow = 'auto'
      }
      this.$emit('closedialog')
    },
    openlog(val) {
      this.$emit('openlog', val)
    },
    nextvali() {
      this.$emit('nextvali')
    },
    createserve() {
      this.$emit('createserve')
    },
    tokefufn() {
      // 跳转到人工客服
      // this.$emit('tokefufn')
      this.$emit('tokefufn')
    },
    tohelp() {
      console.log(123)
      this.$emit('tohelp')
    }
  }
}
